import List from '../../../generic/List';
import type { Repository } from '../../../../types';

import ConnectableProjectRow from './ConnectableProjectRow';
import ImportedProjectRow from './ImportedProjectRow';
import UnimportedProjectRow from './UnimportedProjectRow';
import type { OnBranchChangeFn, OnImportRepositoryFn, OnSelectRepositoryFn } from './types';

import styles from './index.module.less';

export type HybridProjectsServiceImportRepositoriesTableProps = {
  repositories: Repository[];
  onBranchChange: OnBranchChangeFn;
  selectedRepos: Repository[];
  onSelectRepository: OnSelectRepositoryFn;
  onImportRepository: OnImportRepositoryFn;
};

/**
 * A table component just for hybrid-project imports
 *
 * repositories - Row data for the table
 */
const HybridProjectsTable = ({
  repositories,
  onBranchChange,
  selectedRepos,
  onSelectRepository,
  onImportRepository,
} : HybridProjectsServiceImportRepositoriesTableProps) => {
  return (
    <div className={styles.hybridTable}>
      <List>
        <List.Header>
          <span className={styles.column} />
          <span className={styles.column}>Title</span>
          <span className={styles.column}>Branch</span>
          <span className={styles.column}>Status</span>
          <span className={`${styles.column} ${styles.actionColumn}`}>Action</span>
        </List.Header>
        <List.Body>
          {
            repositories.map((repo: Repository) => {
              const isConnectable = repo.connectableProjects?.length;
              const isImported = !!repo.project || repo.connectedProjects?.length;
              if (isImported) {
                return (
                  <ImportedProjectRow repo={repo} />
                );
              }
              if (isConnectable) {
                return (
                  <ConnectableProjectRow
                    repo={repo}
                    selectedRepos={selectedRepos}
                    onBranchChange={onBranchChange}
                    onSelectRepository={onSelectRepository}
                    onImportRepository={onImportRepository}
                  />
                );
              }
              return (
                <UnimportedProjectRow
                  repo={repo}
                  onBranchChange={onBranchChange}
                  onSelectRepository={onSelectRepository}
                  selectedRepos={selectedRepos}
                  onImportRepository={onImportRepository}
                />
              );
            })
          }
        </List.Body>
      </List>
    </div>
  );
};

export default HybridProjectsTable;
